const state = {
    unitOptions: [
        {
            name: 'шт.',
            html: '/шт.',
            id: 2,
        },
        {
            name: 'ед',
            html: '/ед.',
            id: 3,
        },

        {
            name: 'м2',
            html: '/м<sup>2</sup>',
            id: 1,
        },
        {
            name: 'м3',
            html: '/м<sup>3</sup>',
            id: 4,
        },
        {
            name: 'м. пог.',
            html: '/м. пог.',
            id: 5,
        },
    ],
};
const getters = {};
const actions = {};
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
